export { default as zhCN, mergeLocale } from './lang/zh-CN';
export type { PartialLocale } from './lang/zh-CN';
export { default as zhHK } from './lang/zh-HK';
export { default as zhTW } from './lang/zh-TW';
export { default as enUS } from './lang/en-US';
export { default as jaJP } from './lang/ja-JP';
export { default as frFR } from './lang/fr-FR';
